<template>
    <div>
        <van-list
            v-model="listLoading"
            :class="{ 'extra-padding': multi }"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <van-checkbox-group
                ref="checkboxGroup"
                v-model="checked"
                @change="detecetBoxChange"
            >
                <div
                    class="product-list"
                    v-for="item in list"
                    :key="item[rowKey]"
                >
                    <div class="head-row line" v-if="item.isHead">
                        {{ item.name }}
                    </div>
                    <div class="row" v-else>
                        <div class="main-row">
                            <div
                                class="name-box"
                                :class="{ line: item.lineClass }"
                            >
                                <van-checkbox
                                    class="mr"
                                    v-if="multi"
                                    :name="item[rowKey]"
                                    shape="square"
                                ></van-checkbox>
                                <div class="name" @click.stop="goToView(item)">
                                    {{ item[item.nameKey || nameKey] }}
                                </div>
                            </div>
                            <div class="button">
                                <div class="icon" v-if="!item.hideStar">
                                    <van-icon
                                        :name="
                                            bookDic[item[rowKey]]
                                                ? 'star'
                                                : 'star-o'
                                        "
                                        @click.stop="star(item)"
                                    ></van-icon>
                                </div>
                                <template v-if="item._showMail">
                                    <div class="icon">
                                        <van-icon
                                            name="envelop-o"
                                            @click.stop="sendToMail(item)"
                                        ></van-icon>
                                    </div>
                                    <div class="icon">
                                        <van-icon
                                            name="down"
                                            @click.stop="download(item)"
                                        ></van-icon>
                                    </div>
                                </template>
                                <div class="icon">
                                    <van-icon
                                        name="eye-o"
                                        @click.stop="goToView(item)"
                                    ></van-icon>
                                </div>
                            </div>
                        </div>
                        <div
                            class="desc"
                            :class="multi ? 'desc-multi' : ''"
                            v-if="(showDesc || item.showDesc) && item[descKey]"
                        >
                            {{ item[descKey] }}
                        </div>
                    </div>
                </div>
            </van-checkbox-group>
        </van-list>
        <div class="multi-selectbar" v-if="multi">
            <div class="left">
                <van-checkbox
                    v-model="checkedAll"
                    @change="checkAll"
                    shape="square"
                    >全选</van-checkbox
                ><span class="total">（已选择{{ checked.length }}个）</span>
            </div>
            <van-button
                class="right"
                block="block"
                type="info"
                icon="envelop-o"
                :disabled="!checked.length"
                @click="sendMultiToMail"
                >发送邮箱</van-button
            >
        </div>
    </div>
</template>

<script>
import { sleep } from '@/utils/common'
import productActions from '@/views/mixins/productActions'
import bookMarksAction from '@/views/mixins/bookMarksAction'
export default {
    name: 'viewList',
    mixins: [productActions, bookMarksAction],
    props: {
        multi: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        dataSource: {
            type: Array,
            default() {
                return []
            }
        },
        rowKey: {
            type: String,
            default: 'id'
        },
        nameKey: {
            type: String,
            default: 'name'
        },
        descKey: {
            type: String,
            default: 'desc'
        },
        showDesc: {
            type: [Function, Boolean],
            default: false
        },
        showMail: {
            type: [Function, Boolean],
            default: false
        },
        pageSize: {
            type: Number,
            default: 20
        }
    },
    data() {
        return {
            finished: false,
            currentLength: 0,
            listLoading: false,
            checked: [],
            checkedAll: false
        }
    },
    computed: {
        list() {
            this.dataSource.forEach(item => {
                const type = typeof this.showMail
                if (type === 'boolean') {
                    item._showMail = this.showMail
                } else if (type === 'function') {
                    item._showMail = this.showMail(item)
                } else {
                    item._showMail = false
                }
            })
            return this.dataSource.slice(0, this.currentLength)
        }
    },
    methods: {
        detecetBoxChange(checkedGroup) {
            this.checkedAll = checkedGroup.length === (this.dataSource.filter(item=>!item.isHead)).length
        },
        sendMultiToMail() {
            this.sendToMail(
                this.dataSource.filter(
                    cur =>
                        this.checked.includes(cur[this.rowKey]) && cur.pdfLink
                )
            )
        },
        checkAll(checkAll) {
            if (
                checkAll ||
                !this.checked.length ||
                this.checked.length === (this.dataSource.filter(item=>!item.isHead)).length
            ) {
                this.$refs.checkboxGroup.toggleAll(checkAll)
            }
        },
        async onLoad() {
            if (this.loading) return
            this.listLoading = true
            await sleep(150)
            this.currentLength += this.pageSize
            this.listLoading = false
            if (this.dataSource.length <= this.currentLength) {
                this.finished = true
            }
        },
        goToView(item) {
            this.$emit('goToView', item)
        }
    },
    created() {
        this.bindBookMarks()
    },
    watch: {
        loading: {
            handler(v) {
                if (v) {
                    this.finished = false
                    this.currentLength = 0
                }
                this.listLoading = v
            },
            immediate: true
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/style/mixin.less';
.extra-padding {
    margin-bottom: 2.4rem;
}
.head-row {
    line-height: 2.1rem;
}
.line {
    display: flex;
    align-items: center;
    &::before {
        content: '';
        display: inline-block;
        background: @blue;
        width: 0.1rem;
        height: 0.8rem;
        margin-right: 0.4rem;
    }
}
.row {
    padding: 0.6rem 0;
    width: 100%;
    border-bottom: 1px solid #ebebeb;
    .main-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .desc {
        margin-top: @padding-sm;
        color: @gray-6;
        .ellipsis;
        &.desc-multi{
            padding-left: 1.5rem;
        }
    }
    .name-box {
        display: flex;
        align-items: center;
        overflow: hidden;
    }
    .mr {
        margin-right: @padding-sm;
    }
    .name {
        .ellipsis;
        flex: 1;
    }
    .button {
        display: flex;
        align-items: center;
        color: @blue;
        font-size: 0.8rem;
        // max-width: 150px;
        .icon {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: @blue;
            i {
                padding: 0 @padding-xs;
            }
            &:not(:last-child) {
                &::after {
                    content: '';
                    display: block;
                    width: 1px;
                    height: 0.6rem;
                    background: @blue;
                }
            }
        }
    }
}
.multi-selectbar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2.4rem;
    display: flex;
    background: #f9f9f9;
    font-size: 0.65rem;
    .left,
    .right {
        flex: 1;
    }
    .left {
        display: flex;
        align-items: center;
        padding-left: @spacing;
        .total {
            color: #999999;
        }
    }
    .right {
        justify-content: center;
        height: 100%;
        border-radius: 0;
    }
}
</style>
